import generator from 'generate-password-browser';
import APIV5 from '~/models/api';

export default /* @ngInject */ (
	/** @type {any} */ $scope,
	/** @type {import('angular').ITimeoutService} */ $timeout,
) => {
	$scope.deleteRule = () => {
		$scope.component.validate.pattern = undefined;
		$scope.component.description = undefined;
	};

	$scope.generate = (/** @type {number} */ index) => {
		if (!Array.isArray($scope.data[$scope.component.key])) {
			$scope.data[$scope.component.key] = [];
		}

		if (!$scope.data[$scope.component.key]?.name) {
			$scope.data[$scope.component.key][index] = {
				name: undefined,
				process: {
					value: 'K_NODE;HASH',
				},
			};
		}

		$scope.data[$scope.component.key][index].name = generator.generate({
			length:                   10,
			numbers:                  true,
			symbols:                  true,
			excludeSimilarCharacters: true,
		});
	};

	$scope.isRequired = (
		/** @type {any} */ component,
		/** @type {string[]} */ componentsToRequire,
	) => component.validate?.card?.isRequired()
		|| (Array.isArray(componentsToRequire) && componentsToRequire.includes(component.key));

	$scope.updateRule = async (/** @type {any} */ value) => {
		if (value?.kid) {
			const repre = await APIV5.instance.objectRepreGet({
				items:    [value.kid],
				mode:     'all',
			}, {
				id: 'password.config.update-rule',
			});
			$timeout(() => {
				$scope.component.validate.pattern = repre?.result[value.kid]?.repre_all['K_NODE;REGEX']?.name ?? undefined;
				$scope.component.description = repre?.result[value.kid]?.repre_all['K_NODE;DESCRIPTION']?.name ?? undefined;
			});
		}
		else {
			$scope.component.validate.pattern = undefined;
		}
	};
};